var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 47.6001C32.0167 47.6001 30.0334 46.8351 28.5317 45.3334L10.0584 26.8601C9.23672 26.0384 9.23672 24.6784 10.0584 23.8567C10.8801 23.0351 12.2401 23.0351 13.0617 23.8567L31.5351 42.3301C32.8951 43.6901 35.1051 43.6901 36.4651 42.3301L54.9384 23.8567C55.7601 23.0351 57.1201 23.0351 57.9417 23.8567C58.7634 24.6784 58.7634 26.0384 57.9417 26.8601L39.4684 45.3334C37.9667 46.8351 35.9834 47.6001 34.0001 47.6001Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f9e0b3a636ed5c7e3baeb71dea38e135.svg";
export { ForwardRef as ReactComponent };